module.exports = __tmimport("tmng_version_hash");